import { render, staticRenderFns } from "./MatterForm.vue?vue&type=template&id=15c6ee26&scoped=true"
import script from "./MatterForm.vue?vue&type=script&lang=js"
export * from "./MatterForm.vue?vue&type=script&lang=js"
import style0 from "./MatterForm.vue?vue&type=style&index=0&id=15c6ee26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c6ee26",
  null
  
)

export default component.exports